<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="title">
        <span slot="label">
          <a-tooltip>
           {{$t('任务标题')}} <template slot="title"> {{$t('任务标题')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.title" :maxLength="255" :placeholder="$t('请输入')+$t('任务标题')" :disabled="formType===3" >
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['title']"
            input-type="input"
            table-name="task"
            table-field="title"
            :field-value="form.title"
          />
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="cover">
        <span slot="label">
          <a-tooltip>
            {{$t('主图/视频')}}<template slot="title">{{$t('主图/视频')}}</template>
          </a-tooltip>
        </span>
        <oss-upload-single v-model="form.cover" prefix="goods" type="img" :disabled="formType===3" />
        <span>{{ $t('推荐尺寸') }} 400 x 400</span>
      </a-form-model-item>
      <a-form-model-item prop="startTime">
        <span slot="label">
          <a-tooltip>
            {{ $t('开始时间') }}<template slot="title"> {{ $t('开始时间') }}</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.startTime" format="YYYY-MM-DD HH:mm:ss" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                       valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear :disabled="formType===3" />
      </a-form-model-item>
      <a-form-model-item prop="endTime">
        <span slot="label">
          <a-tooltip>
             {{ $t('结束时间') }}<template slot="title"> {{ $t('结束时间') }}</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.endTime" format="YYYY-MM-DD HH:mm:ss" :show-time="{defaultValue:  moment('23:59:59', 'HH:mm:ss')}"
                       valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear :disabled="formType===3" />
      </a-form-model-item>
      <a-form-model-item prop="rewardPoints">
        <span slot="label">
          <a-tooltip>
             {{ $t('奖励积分') }}<template slot="title"> {{ $t('奖励积分') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.rewardPoints" :placeholder="$t('请输入')+ $t('奖励积分')" :disabled="formType===3" />
      </a-form-model-item>
      <a-form-model-item prop="enabled">
        <span slot="label">
          <a-tooltip>
             {{$t('状态')}}<template slot="title">  {{$t('状态')}}</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.enabled" :disabled="formType===3">
          <a-radio :value="1">
            {{$t('是')}}
          </a-radio>
          <a-radio :value="0">
            {{$t('否')}}
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="detail">
        <span slot="label">
          <a-tooltip>
             {{$t('任务详情')}}<template slot="title"> {{$t('任务详情')}}</template>
          </a-tooltip>
        </span>
        <editor v-model="form.detail" :disabled="formType===3" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button v-if="formType !== 3" type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getTask, addTask, updateTask } from '@/api/task/task'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'
import moment from 'moment'
import Editor from '@/components/Editor/Editor.vue'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    LocaleFieldButton,
    OssUploadSingle,
    Editor,
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        goodsId: null,

        title: null,

        cover: null,

        startTime: null,

        endTime: null,

        rewardPoints: null,

        detail: null,

        status: 0,
        localeFieldMap :{},
        enabled: null

      },
      // 1增加,2修改,3查看
      formType: 1,
      open: false,
      rules: {
        title: [
          { required: true, message: '任务标题' + this.$t('不能为空'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '开始时间' + this.$t('不能为空'), trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '结束时间' + this.$t('不能为空'), trigger: 'blur' }
        ],
        rewardPoints: [
          { required: true, message: '奖励积分' + this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: '任务状态 0=预热中 1=进行中 2=已结束' + this.$t('不能为空'), trigger: 'blur' }
        ],
        enabled: [
          { required: true, message: '启用状态 0=否 1=是' + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    moment,
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        goodsId: null,
        title: null,
        cover: null,
        startTime: null,
        endTime: null,
        rewardPoints: null,
        detail: null,
        status: 0,
        localeFieldMap :{},
        enabled: 1
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTask({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 修改按钮操作 */
    handleView(row, ids) {
      this.reset()
      this.formType = 3
      const id = row ? row.id : ids
      getTask({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('查看详情')
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateTask(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addTask(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
